export default __webpack_public_path__ + "static/media/banner_encerrado_mobile-80.44947cb8.jpg";